module.exports = __webpack_public_path__ + "img/instagram_story_icons.33bd3c24.png";